import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BackendApiService } from '../../services/backend-api.service';
import { BaseUrlConstantsService } from '../../services/base-url-constants.service';
@Component({
  selector: 'app-settings-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './settings-modal.component.html',
  styleUrl: './settings-modal.component.scss'
})
export class SettingsModalComponent {
  _sensorGroupData: any[] = [];
  sensorKWpowerGroupData: any[] = [];
  assetType: string = 'MOTOR';
  fftBaseValue = 'VEL';
  showKurtosis = false;
  kurt_threshold: number = 0;
  kurt_freq: number = 0;
  kurt_anomaly_counter: number = 0;
  assetStatus: any = 0;
  originalData: any[] = [];
  master_type='';

  constructor(
    public dialogRef: MatDialogRef<SettingsModalComponent>, public service: BackendApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { console.log(data) }



  ngOnInit() {
    this.originalData = JSON.parse(JSON.stringify(this.data.metrics));
    if(this.data.is_temperature_added!=1){
      this.data.metrics=this.data.metrics.filter(m=> !m.metric_type.startsWith("temperature"))
    }
    this.master_type=JSON.parse(JSON.stringify(this.data.master_type));
    this.kurt_threshold = this.data.metrics[0].kurt_threshold;
    this.kurt_freq = this.data.metrics[0].kurt_freq;
    this.kurt_anomaly_counter = this.data.metrics[0].kurt_anomaly_counter;
    this.assetStatus = this.data.assetStatus;
    this.showKurtosis=this.master_type=='4'?false:true

    this._sensorGroupData = this.data.metrics.filter((item: any) =>
      !item.metric_type.startsWith("kwrating")
    );

    this._sensorGroupData = this.data.metrics.filter((item: any) =>
      item.metric_type.startsWith("acceleration") || item.metric_type.startsWith("temperature") || item.metric_type.startsWith("displacement")
    );

    this.sensorKWpowerGroupData = this.data.metrics.filter((item: any) =>
      item.metric_type.startsWith("kwrating")
    );

  }

  onInputChange() {
  }

  close() {
    this.dialogRef.close();
  }

  async saveSensorSettings() {
    let temperature_mqtt_payload=[];
    let velocity_mqtt_payload=[];
    const payloadList: any[] = [];
    console.log(this._sensorGroupData)

    // Loop through all standard sensor metric rows
    this._sensorGroupData.forEach((sensor, idx) => {
      const updated = {
        id: sensor.id,
        base_value: Number((document.getElementById(`base_value_${idx}`) as HTMLInputElement)?.value),
        max_value: Number((document.getElementById(`max_value_${idx}`) as HTMLInputElement)?.value),
        threshold_1: Number((document.getElementById(`threshold_1_${idx}`) as HTMLInputElement)?.value),
        threshold_2: Number((document.getElementById(`threshold_2_${idx}`) as HTMLInputElement)?.value),
        threshold_3: Number((document.getElementById(`threshold_3_${idx}`) as HTMLInputElement)?.value)
      };

      // Push if values changed compared to original
      const orig = this.originalData.find((x: any) => x.id === sensor.id);

      if (
        updated.threshold_1 !== orig.threshold_1 ||
        updated.threshold_2 !== orig.threshold_2 ||
        updated.threshold_3 !== orig.threshold_3 ||
        updated.base_value !== orig.base_value ||
        updated.max_value !== orig.max_value
      ) {
        payloadList.push(updated);
      }

      if(sensor.metric_type.startsWith("temperature")){
        console.log(updated)
        temperature_mqtt_payload.push(
          updated.base_value,
          updated.base_value+(updated.threshold_1/100)*(updated.max_value-updated.base_value),
          updated.base_value+(updated.threshold_2/100)*(updated.max_value-updated.base_value),
        )
        console.log(temperature_mqtt_payload)
      }
    });

    // Velocity (KWRATING) data
    this._sensorGroupData.forEach((sensor, idx) => {
      const updated = {
        id: sensor.id,
        base_value: Number((document.getElementById(`base_value_${idx}`) as HTMLInputElement)?.value),
        max_value: Number((document.getElementById(`max_value_${idx}`) as HTMLInputElement)?.value),
        threshold_1: Number((document.getElementById(`threshold_1_${idx}`) as HTMLInputElement)?.value),
        threshold_2: Number((document.getElementById(`threshold_2_${idx}`) as HTMLInputElement)?.value),
        threshold_3: Number((document.getElementById(`threshold_3_${idx}`) as HTMLInputElement)?.value)
      };

      const orig = this.originalData.find((x: any) => x.id === sensor.id);

      // --- ADDED CHECKS FOR base_value AND max_value BELOW ---
      if (
        updated.threshold_1 !== orig.threshold_1 ||
        updated.threshold_2 !== orig.threshold_2 ||
        updated.threshold_3 !== orig.threshold_3 ||
        updated.base_value !== orig.base_value ||
        updated.max_value !== orig.max_value
      ) {
        payloadList.push(updated);
      }
    });

    this.sensorKWpowerGroupData.forEach((sensor, idx) => {
      console.log(sensor)
      // FIX A: Iterate over sensorKWpowerGroupData, not _sensorGroupData

      const updated = {
        id: sensor.id,
        // FIX B: In your HTML, base_value is disabled, so we keep the original value from the object
        base_value: sensor.base_value,
        max_value: Number((document.getElementById(`threshold_3_dev${idx}`) as HTMLInputElement)?.value),

        // FIX C: Update IDs to match HTML (threshold_1_dev, threshold_2_dev, etc.)
        threshold_1: Number((document.getElementById(`threshold_1_dev${idx}`) as HTMLInputElement)?.value),
        threshold_2: Number((document.getElementById(`threshold_2_dev${idx}`) as HTMLInputElement)?.value),
        threshold_3: Number((document.getElementById(`threshold_3_dev${idx}`) as HTMLInputElement)?.value)
      };

      const orig = this.originalData.find((x: any) => x.id === sensor.id);

      if (
        updated.threshold_1 !== orig.threshold_1 ||
        updated.threshold_2 !== orig.threshold_2 ||
        updated.threshold_3 !== orig.threshold_3
      ) {
        velocity_mqtt_payload.push(
          updated.base_value,
          updated.threshold_1,
          updated.threshold_2
        )
        payloadList.push(updated);
      }
    });



    // Make PUT request for each item
    // for (const item of payloadList) {
    //   try {
    //     const response: any = await this.service.putData(`${BaseUrlConstantsService.ASSET_METRICS}/${item.id}`, item);

    //   } catch (err) {
    //     console.error("Update failed:", err);
    //   }
    // }
    Promise.all(
      payloadList.map(item =>
        this.service.putData(
          `${BaseUrlConstantsService.ASSET_METRICS}/${item.id}`,
          item
        )
      )
    ).then(async () => {
      if(!temperature_mqtt_payload.length && !velocity_mqtt_payload.length){
        console.log('No MQTT SPECIFIC UPDATES!')
      }
      await this.service.postData(`${BaseUrlConstantsService.BASE_PIEZO_SERVICE}/api/publish_metrics`,{subsystem_id:this.data.subsystem_id,asset_id:this.data.assetId});
    }).catch((err) => {
      console.error("Update failed:", err);
    });


    const firstItem = this.data.metrics[0];

    const new_kurt_threshold = Number((document.getElementById("kurt_threshold") as HTMLInputElement)?.value);
    const new_kurt_freq = Number((document.getElementById("kurt_frequency") as HTMLInputElement)?.value);
    const new_kurt_anomaly_counter = Number((document.getElementById("kurt_anomaly_counter") as HTMLInputElement)?.value);

    // Check if kurtosis values changed
    if (
      new_kurt_threshold !== firstItem.kurt_threshold ||
      new_kurt_freq !== firstItem.kurt_freq ||
      new_kurt_anomaly_counter !== firstItem.kurt_anomaly_counter
    ) {
      const kurtosisPayload = {
        kurt_freq: new_kurt_freq,
        kurt_threshold: new_kurt_threshold,
        kurt_anomaly_counter: new_kurt_anomaly_counter,
        asset_id: firstItem.asset_id,
        user_id: firstItem.user_id,
        index_ref: 10,
        id: "test_id"
      };

      try {
        await this.service.putData(`${BaseUrlConstantsService.ASSET_METRICS}/test_id`, kurtosisPayload);
      } catch (err) {
        console.error("Kurtosis update failed:", err);
      }
    }

    this.dialogRef.close(true);
  }

}
